import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  () => ({
    root: {},
  }),

  { name: 'NotFoundView' },
);

export default useStyles;
